export default __webpack_public_path__ + "static/media/circuloVerde.cc123eab.jpg";